<template>
    <div v-if="enabledExtensions.length !== 0">
        <template v-for="extension in enabledExtensions">
            <component :is="extension.name" :settings="entity"></component>
        </template>
    </div>
</template>

<script>
import {componentTypeExtensionsList, FormExtensionLevel, FormExtensions} from '@/types/document-viewer/extension'
import {mapGetters} from 'vuex'

export default {
    name: 'DocumentViewerComponentExtensions',
    components: {
        [FormExtensions.CONTACT_SELECT]: () => import(/* webpackChunkName: "contact_select" */ './field/ExtensionContactSelect'),
        [FormExtensions.CURRENCY_CONVERSION]: () => import(/* webpackChunkName: "currency_conversion" */ './field/ExtensionCurrencyConversion'),
        [FormExtensions.CONTACT_ABN]: () => import(/* webpackChunkName: "contact_abn" */ './field/ExtensionAbnCheck'),
        [FormExtensions.CONTACT_BANK_DETAILS]: () => import(/* webpackChunkName: "contact_bank_details" */ './field/ExtensionBankDetailsCheck'),
        [FormExtensions.ADDRESS_SELECT]: () => import(/* webpackChunkName: "address_select" */ './section/ExtensionAddressSelect')
    },
    props: {
        level: {
            type: String, // FormExtensionLevel
            required: true
        },
        entity: { // FormField if FormExtensionLevel.FIELD | FormSection if FormExtensionLevel.SECTION
            type: Object,
            required: true
        },
        extensions: { // enabled extensions
            type: Array,
            required: true
        }
    },
    computed: {
        ...mapGetters('doc_viewer_settings', [
            'checkIsAvailableExtension'
        ]),

        enabledExtensions() {
            return componentTypeExtensionsList
                .filter(e => this.level === e.level &&
                    this.extensions.some(ex => ex.name === e.name) &&
                    this.checkIsAvailableExtension(e.name) && (
                        (this.level === FormExtensionLevel.FIELD && e.available.fields && e.available.fields.includes(this.entity.path)) ||
                        (this.level === FormExtensionLevel.SECTION && e.available.sections && e.available.sections.includes(this.entity.key))
                    ))
        }
    }
}
</script>
